var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-container"},[_c('h1',{staticClass:"shadow"},[_vm._v("This link is invalid or has expired.")])])
}]

export { render, staticRenderFns }